import {Component, Input} from '@angular/core';
import {ProyectoItem} from "../../../../interfaces/proyecto.interface";
import {NgIf} from "@angular/common";
import {TagModule} from "primeng/tag";
import {AccordionModule} from "primeng/accordion";
import {TabViewModule} from "primeng/tabview";
import {TableModule} from "primeng/table";
import {TooltipModule} from "primeng/tooltip";
import {InputNumberModule} from "primeng/inputnumber";
import {PrimeNgModule} from "../../../../../shared/prime-ng/prime-ng.module";
import {parseTieneProyectoDefinido, parseToFormatNumber} from "../../../../../shared/services/utils-service";
import {DetalleConstruccionItemComponent} from "./detalle-construccion-item/detalle-construccion-item.component";

@Component({
    selector: 'app-generales-proyecto',
    standalone: true,
    imports: [
        NgIf,
        TagModule,
        AccordionModule,
        TabViewModule,
        TableModule,
        TooltipModule,
        InputNumberModule,
        PrimeNgModule,
        DetalleConstruccionItemComponent
    ],
    templateUrl: './generales-proyecto.component.html',
    styleUrl: './generales-proyecto.component.scss'
})
/**
 * Este componente es reutilizado en procesos de clientes y funcionarios.
 */
export class GeneralesProyectoComponent {
    static RP: string = "RP_";
    private _prj: ProyectoItem | null = null;
    public is_ProyectoRegistroProfesional: boolean = false;

    constructor() {
    }

    @Input()
    set prj(data: ProyectoItem | null) {
        this._prj = data
        if (data) {
            //onChange detected
            this.is_ProyectoRegistroProfesional = this.isProyectoRegistroProfesional()
        }
    };

    get prj(): ProyectoItem | null {
        return this._prj
    }

    /**
     * Esta bandera controla si el componente muestra el título del proyecto.
     */
    @Input() rendertitle: boolean = false;
    protected readonly parseToFormatNumber = parseToFormatNumber;
    protected readonly parseTieneProyectoDefinido = parseTieneProyectoDefinido;
    /**
     * Con este input obtendremos un booleano que nos indicara si realmente es o no es
     * de la categoria de registro profesional, ya que se requiere ocultar algunos
     * elementos que coincidan
     */
    @Input() isRegistroProfesional: boolean = false;
    /**
     * Con este input obtendremos un booleano que nos indicara si realmente se debe o no
     * mostrar el titulo del componente
     */
    @Input() hideTitle: boolean = false
    /**
     * Con este input obtendremos un booleano que nos indicara si realmente se debe o no
     * mostrar la descripcion del componente
     */
    @Input() hideDescription: boolean = false

    isProyectoRegistroProfesional(): boolean {
        return this.prj?.nombre.startsWith(GeneralesProyectoComponent.RP) || false;
    }
}
